import {
	SCROLL_TO_TOP,
	RESET_SCROLL_TO_TOP,
	SCROLL_TO_DIRECTOR_MESSAGE,
	RESET_SCROLL_TO_DIRECTOR_MESSAGE,
	SCROLL_TO_INFORMATION,
	RESET_SCROLL_TO_INFORMATION,
	SCROLL_TO_PROGRAM,
	RESET_SCROLL_TO_PROGRAM,
	SCROLL_TO_DIRECTION,
	RESET_SCROLL_TO_DIRECTION,
	SCROLL_TO_OPINIONS,
	RESET_SCROLL_TO_OPINIONS,
	SCROLL_TO_CONTACT,
	RESET_SCROLL_TO_CONTACT
} from '../constants';

const initialState = {
	scrollToTop: false,
	scrollToDirectorMessage: false,
	scrollToInformation: false,
	scrollToProgram: false,
	scrollToDirection: false,
	scrollToOpinions: false,
	scrollToContact: false
};

const scroll = (state = initialState, action) => {
	switch (action.type) {
		case SCROLL_TO_TOP:
			return {
				...state,
				scrollToTop: true
			};
		case RESET_SCROLL_TO_TOP:
			return {
				...state,
				scrollToTop: false
			};
		case SCROLL_TO_DIRECTOR_MESSAGE:
			return {
				...state,
				scrollToDirectorMessage: true
			};
		case RESET_SCROLL_TO_DIRECTOR_MESSAGE:
			return {
				...state,
				scrollToDirectorMessage: false
			};
		case SCROLL_TO_INFORMATION:
			return {
				...state,
				scrollToInformation: true
			};
		case RESET_SCROLL_TO_INFORMATION:
			return {
				...state,
				scrollToInformation: false
			};
		case SCROLL_TO_PROGRAM:
			return {
				...state,
				scrollToProgram: true
			};
		case RESET_SCROLL_TO_PROGRAM:
			return {
				...state,
				scrollToProgram: false
			};
		case SCROLL_TO_DIRECTION:
			return {
				...state,
				scrollToDirection: true
			};
		case RESET_SCROLL_TO_DIRECTION:
			return {
				...state,
				scrollToDirection: false
			};
		case SCROLL_TO_OPINIONS:
			return {
				...state,
				scrollToOpinions: true
			};
		case RESET_SCROLL_TO_OPINIONS:
			return {
				...state,
				scrollToOpinions: false
			};
		case SCROLL_TO_CONTACT:
			return {
				...state,
				scrollToContact: true
			};
		case RESET_SCROLL_TO_CONTACT:
			return {
				...state,
				scrollToContact: false
			};
		default:
			return state;
	}
};

export default scroll;
